import { Component, PropTypes } from 'react';
import Sticky from 'react-stickydiv';
import Section from 'components/Section';
import cx from 'classnames';
import { messageSections } from 'config';
import styles from './styles.css';

export default class SectionsHeader extends Component {
	static propTypes = {
		sectionIndex: PropTypes.number.isRequired,
		onSectionChange: PropTypes.func.isRequired
	}

	render() {
		return (
			<Sticky>
				<Section section={messageSections[this.props.sectionIndex]} />

				<div className={styles.parts}>
					{messageSections.map(({ number }, index) =>
						<div key={index}
							className={cx(styles.part, {[styles.active]: index === this.props.sectionIndex})}
							onClick={() => this.props.onSectionChange(index)}>{number}</div>
					)}
				</div>
			</Sticky>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./components/SectionHeader/index.js
 **/